export default theme => ({
  searchBox: {
    display: "flex",
    alignItems: "baseline",
  },
  select_label: {
    fontSize: 12,
  },
});
